import {
  AddressVerificationRequest,
  AddressVerificationResult,
} from "@t3/shared";
import { createHttpsCallableHook } from "./createHttpsCallableHook";

const middlewareOnCallAddressRequest = (
  request: AddressVerificationRequest,
): AddressVerificationRequest => {
  if (
    !request.address ||
    !request.city ||
    !request.state ||
    !request.zipCode ||
    !request.phoneNumber
  ) {
    throw new Error("All address fields are required");
  }
  return request;
};

export const useVerifyAddress = createHttpsCallableHook<
  AddressVerificationRequest,
  AddressVerificationResult
>("verifyUserAddress", middlewareOnCallAddressRequest);
